/* import __COLOCATED_TEMPLATE__ from './confirm-deactivation-all-cards.hbs'; */
import Component from '@glimmer/component';
export default class ConfirmDeactivationAllCards extends Component {}